import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px 12px 34px;
    border-bottom: 1px solid #ececf0;
    ${mq.lt.md} {
        flex-direction: column;
        padding: 16px 12px;
        align-items: start;
    }

    .imgBlockMax {
        position: relative;
        display: flex;
        margin: 0 auto 16px;
        width: 100%;
        height: 100%;
        min-height: 170px;
        min-width: 120px;

        & img {
            width: initial !important;
            min-width: initial !important;
            margin: 0 auto;
        }

        ${mq.gt.md} {
            display: none;
        }
    }
`;

export const HeaderInfoWrapper = styled.div`
    ${mq.lt.md} {
        margin-bottom: 16px;
    }

    .title {
        max-width: 560px;
        text-transform: lowercase;

        ::first-letter {
            text-transform: uppercase;
        }

        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 120%;
        color: #1f2547;
        margin-bottom: 8px;
    }

    .contract {
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 120%;
        color: #00d9de;
        cursor: pointer;
    }
`;
